import { useEffect, useRef, useState } from "react";
import {
    BellOutlined,
    CheckCircleOutlined, CheckOutlined, CloseCircleOutlined, DeleteOutlined,
    LeftOutlined,
    RightOutlined, SettingOutlined,
} from "@ant-design/icons";
import { Badge, Button, Divider, Menu, Popover, Spin, Typography } from "antd";
import { t } from "i18next";
import ApiService from "../core/service/ApiService";

export default function NotificationMenu({ }) {
    const [notifications, setNotifications] = useState([])
    const [page, setPage] = useState(0)
    const updateRef = useRef(new Date())
    const [intervalTime, setIntervalTime] = useState(60000)

    const getNotifications = async () => {
        const res = await ApiService.Notification.GetNotificationList(page)
        if (res.success) {
            setNotifications(res.data)
            updateRef.current = new Date()
        }
    }

    useEffect(() => {
        const id = setInterval(async () => {
            await getNotifications()
        }, intervalTime)

        return () => {
            clearInterval(id)
        }
    }, [intervalTime]);

    useEffect(() => {
        if (page === -1) {
            setPage(0)
            return
        }
        getNotifications()
    }, [page]);

    const getIcon = (status) => {
        if (status === 1)
            return <Spin spinning={true} size={'small'} />
        if (status === 2)
            return <CheckCircleOutlined twoToneColor="#52c41a" />
        if (status === 3)
            return <CloseCircleOutlined />
    }

    const getActionButton = (notification) => {
        if (notification.type === 0 && [2, 4].includes(notification.status)) {
            return (
                <a
                    onClick={() => setRead(notification.id)}
                    href={'/app/appointments/entitlements/confirm'}
                    style={{ cursor: 'pointer' }}
                >
                    {t('Open')}
                </a>
            )
        }
    }

    const setRead = async (id) => {
        const res = await ApiService.Notification.SetRead(id)
        if (res.success) {
            await getNotifications()
        }
    }

    const removeItem = async (id) => {
        const res = await ApiService.Notification.RemoveItem(id)
        if (res.success) {
            await getNotifications()
        }
    }

    const clear = async () => {
        const res = await ApiService.Notification.Clear()
        if (res.success) {
            await getNotifications()
        }
    }

    const menu = (
        <div>
            <Typography.Title level={5} style={{ paddingLeft: 8, width: 400 }}>
                {t('Notifications')}
            </Typography.Title>
            {
                notifications.length === 0 && (
                    <Typography.Text style={{ paddingLeft: 8 }}>
                        {t('No Notification')}
                    </Typography.Text>
                )
            }
            {
                notifications.map(n => (
                    <>
                        <div style={{ padding: 4, paddingLeft: 8, paddingRight: 8, width: 400 }}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                    <Typography.Text>
                                        {
                                            n.status === 1 ? `${Math.round((new Date().getTime() - new Date(n.createdDate)) / 1000)} s` : new Date(n.statusDate).toLocaleString()
                                        }
                                    </Typography.Text>
                                    {
                                        !n.readDate && (<div style={{ width: 8, height: 8, backgroundColor: 'red', borderRadius: 4 }}></div>)
                                    }
                                </div>
                                <div>
                                    {
                                        [2, 4].includes(n.status) && !n.readDate && (<Button onClick={() => setRead(n.id)} size={'small'}><CheckOutlined /></Button>)
                                    }
                                    {
                                        [2, 4].includes(n.status) && (<Button onClick={() => removeItem(n.id)} size={'small'}><DeleteOutlined /></Button>)
                                    }
                                </div>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 4 }}>
                                <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', width: '100%' }}>
                                    <Typography.Text style={{ color: 'black', fontWeight: 'bold', marginRight: 8 }} ellipsis={true}>
                                        {n.name}
                                    </Typography.Text>
                                    {getActionButton(n)}
                                </div>
                                {getIcon(n.status)}
                            </div>
                            {
                                n.description && (
                                    <div style={{ fontSize: '9pt', color: '#6a6d70' }}>
                                        {n.description}
                                    </div>
                                )
                            }
                        </div>
                        <Divider style={{ margin: 0 }} />
                    </>
                ))
            }

            <div style={{
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                justifyContent: 'space-between',
                marginTop: 8,
                paddingLeft: 8,
                paddingRight: 8
            }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Button size={'small'} disabled={page === 0} icon={<LeftOutlined />} onClick={(e) => { e.stopPropagation(); setPage(page - 1) }} />
                    <Button size={'small'} disabled={notifications.length === 0 || notifications.length < 5} icon={<RightOutlined />} onClick={(e) => { e.stopPropagation(); setPage(page - 1) }} />
                </div>
                <Button onClick={clear} disabled={notifications.length === 0} size={'small'}>
                    {t('Clear')}
                </Button>
            </div>
        </div>
    )

    return (
        <div>
            <Popover
                content={menu}
                trigger={'click'}
                placement={'bottomLeft'}
                onOpenChange={visible => {   /* v5: onVisibleChange → onOpenChange */
                    if (visible) {
                        setIntervalTime(3000)
                    }
                    else {
                        setIntervalTime(60 * 1000)
                    }
                }}
            >
                {/* header eylemi: şeffaf zemin, kontrast ikon; okunmamış varsa AMBER rozet */}
                <Button
                    type="text"
                    className="header-action"
                    aria-label={t('Notifications')}
                    icon={
                        <Badge
                            count={notifications.filter(x => !x.readDate).length}
                            size="small"
                            offset={[2, -2]}
                        >
                            <BellOutlined style={{ fontSize: 17 }} />
                        </Badge>
                    }
                />
            </Popover>
        </div>
    )
}